import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

interface UseFetchWeekRightOrdersParams {
  weekNumber: number;
  orderLimit?: number;
}

export const useFetchWeekRightOrders = (
  params: UseFetchWeekRightOrdersParams,
) => {
  const { weekNumber, orderLimit = 5 } = params;

  const queryFn = async ({ pageParam = 1 }) => {
    const response = await fetchClient.GET("/nft/week-right-orders", {
      params: {
        query: {
          weekNumber,
          orderPage: typeof pageParam === "number" ? pageParam : 1,
          orderLimit,
        },
      },
    });
    const error = response.error;
    if (error) throw error;
    return response.data;
  };

  const {
    data,
    error,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isFetchNextPageError,
  } = useInfiniteQuery({
    queryKey: ["user", "week-right-orders", weekNumber, orderLimit],
    queryFn,
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.data?.pagination;

      if (pagination?.hasNextPage) return pagination.page + 1;

      return undefined;
    },
    retry: 1,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchInterval: false,
    refetchIntervalInBackground: false,
  });

  return {
    data,
    error,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isFetchNextPageError,
  };
};
